import WmsProvider from "./wms";
import AuthProvider from "./auth";
import AppCatalogCategoryProvider from "./app_catalog_category";
import AppCatalogProductProvider from "./app_catalog_product";
import AppCatalogCampaignProvider from "./app_catalog_campaign";
import AppCatalogPromotionBundleProvider from "./app_catalog_promotion_bundle";
import AppCatalogCouponTemplateProvider from "./app_catalog_coupon_template";
import AppCatalogUploadProvider from "./app_catalog_upload";
import AppCatalogWmsProductProvider from "./app_catalog_wms_product";
import StorefrontProvider from "./storefront";
import SellerProvider from "./seller";
import ShippingTierProvider from "./shipping_tier";
import MemberLevelProvider from "./member_level";
import UserProvider from "./user";
import OrderProvider from "./order";
import ProductProvider from "./product";
import ProductCategoryProvider from "./product_category";
import ReportProvider from "./report";
import PackingProvider from "./packing";
import CustomerProvider from "./customer";
import TiktokProvider from "./platform_tiktok";
import ShopeeProvider from "./platform_shopee";
import LazadaProvider from "./platform_lazada";
import PlatformProvider from "./platform";
import LineProvider from "./platform_line";
import PaymentMethodProvider from "./payment_method";
import SaleChannelProvider from "./sale_channel";
import TeamProvider from "./team";
import DepartmentProvider from "./department";
import CouponProvider from "./coupon";
import POProvider from "./po";
import MemberProvider from "./member";
import PlatformStatementProvider from "./platform_statement";
import KOLProvider from "./kol";
import ModernTradeProvider from "./modernTrade";
import IssueReportProvider from "./issueReport";
import NotificationProvider from "./notification"; // #169
import MenuPrefProvider from "./menuPref";
import TaskbarProvider from "./taskbar"; // taskbar pins synced server-side
import HomeContentProvider from "./home_content"; // #185
import LandingPageProvider from "./landing_page"; // Phase 1 ads — LP CMS
import StorefrontCollectionProvider from "./storefront_collection"; // www collections + discovery sets (2026-10-13)
import AttributionReportProvider from "./attribution_report"; // Phase 1 ads — source report
import ReferralCodeProvider from "./referral_code"; // Phase 2 — referral codes
import ReferralReportProvider from "./referral_report"; // Phase 2 — referral report
import AffiliateProvider from "./affiliate"; // Phase 3 — customer affiliate (program)
import AffiliatePayoutProvider from "./affiliate_payout"; // Phase 3 — affiliate payout rounds
import PlatformMiraklProvider from "./platform_mirakl"; // Makro PRO / Mirakl
import PlatformAmazeProvider from "./platform_amaze"; // Amaze (amaze-x)
import ShippingConfigProvider from "./shipping_config"; // shipping_config -> DB
import PosProvider from "./pos"; // #443 POS หน้าร้าน

const WmsService = new WmsProvider();
const AuthService = new AuthProvider();
const UserService = new UserProvider();
const OrderService = new OrderProvider();
const ProductService = new ProductProvider();
const ProductCategoryService = new ProductCategoryProvider();
const ReportService = new ReportProvider();
const PackingService = new PackingProvider();
const CustomerService = new CustomerProvider();
const TiktokService = new TiktokProvider();
const ShopeeService = new ShopeeProvider();
const LazadaService = new LazadaProvider();
const PlatformService = new PlatformProvider();
const LineService = new LineProvider();
const PaymentMethodService = new PaymentMethodProvider();
const SaleChannelService = new SaleChannelProvider();
const TeamService = new TeamProvider();
const DepartmentService = new DepartmentProvider();
const CouponService = new CouponProvider();
const POService = new POProvider();
const MemberService = new MemberProvider();
const PlatformStatementService = new PlatformStatementProvider();
const KOLService = new KOLProvider();
const ModernTradeService = new ModernTradeProvider();
const AppCatalogCategoryService = new AppCatalogCategoryProvider();
const AppCatalogProductService = new AppCatalogProductProvider();
const AppCatalogCampaignService = new AppCatalogCampaignProvider();
const AppCatalogPromotionBundleService = new AppCatalogPromotionBundleProvider();
const AppCatalogCouponTemplateService = new AppCatalogCouponTemplateProvider();
const AppCatalogUploadService = new AppCatalogUploadProvider();
const AppCatalogWmsProductService = new AppCatalogWmsProductProvider();
const StorefrontService = new StorefrontProvider();
const SellerService = new SellerProvider();
const ShippingTierService = new ShippingTierProvider();
const MemberLevelService = new MemberLevelProvider();
const IssueReportService = new IssueReportProvider();
const NotificationService = new NotificationProvider(); // #169
const MenuPrefService = new MenuPrefProvider();
const TaskbarService = new TaskbarProvider();
const HomeContentService = new HomeContentProvider(); // #185
// Phase 1 ads (spec 2026-10-13 §6.1 / §9): VUE_APP_MARKETING_MOCK=true swaps in
// the in-memory contract mock (development / render checks before bo-api ships).
// Development servers only: the NODE_ENV test is inlined so DefinePlugin +
// webpack const folding drop the require from production builds (Vue CLI defines
// process.env as an object, so VUE_APP_MARKETING_MOCK alone is not folded).
const LandingPageService = process.env.NODE_ENV !== "production" && process.env.VUE_APP_MARKETING_MOCK === "true"
    ? require("./marketing_mock").createLandingPageMock()
    : new LandingPageProvider();
const AttributionReportService = process.env.NODE_ENV !== "production" && process.env.VUE_APP_MARKETING_MOCK === "true"
    ? require("./marketing_mock").createAttributionReportMock()
    : new AttributionReportProvider();
// Phase 2 referral (spec 2026-10-13-phase2 §5.1 / §7.3): same mock switch.
const ReferralCodeService = process.env.NODE_ENV !== "production" && process.env.VUE_APP_MARKETING_MOCK === "true"
    ? require("./referral_mock").createReferralCodeMock()
    : new ReferralCodeProvider();
const ReferralReportService = process.env.NODE_ENV !== "production" && process.env.VUE_APP_MARKETING_MOCK === "true"
    ? require("./referral_mock").createReferralReportMock()
    : new ReferralReportProvider();
// Phase 3 affiliate (spec 2026-10-13-phase3 §5.1 / §7.3): same mock switch.
const AffiliateService = process.env.NODE_ENV !== "production" && process.env.VUE_APP_MARKETING_MOCK === "true"
    ? require("./affiliate_mock").createAffiliateMock()
    : new AffiliateProvider();
const AffiliatePayoutService = process.env.NODE_ENV !== "production" && process.env.VUE_APP_MARKETING_MOCK === "true"
    ? require("./affiliate_mock").createAffiliatePayoutMock()
    : new AffiliatePayoutProvider();
// www collections + discovery sets (spec 2026-10-13 §3.3 / §5.2): same mock switch.
const StorefrontCollectionService = process.env.NODE_ENV !== "production" && process.env.VUE_APP_MARKETING_MOCK === "true"
    ? require("./storefront_collection_mock").createStorefrontCollectionMock()
    : new StorefrontCollectionProvider();
const PlatformMiraklService = new PlatformMiraklProvider(); // Makro PRO / Mirakl
const PlatformAmazeService = new PlatformAmazeProvider(); // Amaze (amaze-x)
const ShippingConfigService = new ShippingConfigProvider(); // shipping_config -> DB
const PosService = new PosProvider(); // #443

export {
    WmsService,
    AuthService,
    UserService,
    OrderService,
    ProductService,
	ProductCategoryService,
    ReportService,
    PackingService,
    CustomerService,
    TiktokService,
    ShopeeService,
    LazadaService,
	PlatformService,
    LineService,
	PaymentMethodService,
	SaleChannelService,
	TeamService,
	DepartmentService,
	CouponService,
    POService,
    MemberService,
    PlatformStatementService,
    KOLService,
    AppCatalogCategoryService,
    AppCatalogProductService,
    AppCatalogCampaignService,
    AppCatalogPromotionBundleService,
    AppCatalogCouponTemplateService,
    AppCatalogUploadService,
    AppCatalogWmsProductService,
    StorefrontService,
    SellerService,
    ShippingTierService,
    MemberLevelService,
    ModernTradeService,
    IssueReportService,
    NotificationService,
    MenuPrefService,
    TaskbarService,
    HomeContentService,
    StorefrontCollectionService,
    LandingPageService,
    AttributionReportService,
    ReferralCodeService,
    ReferralReportService,
    AffiliateService,
    AffiliatePayoutService,
    PlatformMiraklService,
    PlatformAmazeService,
    ShippingConfigService,
    PosService
};
